/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {TemplateCosoRequisitoDTO} from './TemplateCosoRequisitoDTO';

/**
 * The TemplateCosoPrincipioDTO model module.
 * @module model/TemplateCosoPrincipioDTO
 * @version v0
 */
export class TemplateCosoPrincipioDTO {
  /**
   * Constructs a new <code>TemplateCosoPrincipioDTO</code>.
   * @alias module:model/TemplateCosoPrincipioDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TemplateCosoPrincipioDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TemplateCosoPrincipioDTO} obj Optional instance to populate.
   * @return {module:model/TemplateCosoPrincipioDTO} The populated <code>TemplateCosoPrincipioDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TemplateCosoPrincipioDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('templateCosoRequisiti'))
        obj.templateCosoRequisiti = ApiClient.convertToType(data['templateCosoRequisiti'], [TemplateCosoRequisitoDTO]);
      if (data.hasOwnProperty('tooltip'))
        obj.tooltip = ApiClient.convertToType(data['tooltip'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
TemplateCosoPrincipioDTO.prototype.id = undefined;

/**
 * @member {String} title
 */
TemplateCosoPrincipioDTO.prototype.title = undefined;

/**
 * @member {Number} position
 */
TemplateCosoPrincipioDTO.prototype.position = undefined;

/**
 * @member {Array.<module:model/TemplateCosoRequisitoDTO>} templateCosoRequisiti
 */
TemplateCosoPrincipioDTO.prototype.templateCosoRequisiti = undefined;

/**
 * @member {String} tooltip
 */
TemplateCosoPrincipioDTO.prototype.tooltip = undefined;

